module.exports = __webpack_public_path__ + "static/invoker-02-da6e635586ebc2942dcfbc6baada9e51.png";